export default class UserAdminService {
    static getAssignablePermissions() {
        return [
            {name: 'spielbericht', label: 'Spielbericht - bitte Vereinsnummer eingeben',
                type: 'string', show: false, value: ''},
            {name: 'vereinsdatenblaetter', label: 'Alle Vereinsdatenblätter anzeigen',
                type: 'boolean', show: false, value: null},
            {name: 'ergebnisdienst', label: 'Ergebnisdienst - Administrator',
                type: 'boolean', show: false, value: null},
            {name: 'sportobmann', label: 'Sportobmann - bitte Landesverbandsnr. eingeben',
                type: 'string', show: false, value: ''},
            {name: 'sportobmann_1', label: 'Sportobmann 1 Nationale Ligen',
                type: 'boolean', show: false, value: null, tab: 0},
            {name: 'sportobmann_11', label: 'Sportobmann 11 - Burgenland',
                type: 'boolean', show: false, value: null, tab: 0},
            {name: 'sportobmann_12', label: 'Sportobmann 12 - Kärnten',
                type: 'boolean', show: false, value: null, tab: 0},
            {name: 'sportobmann_13', label: 'Sportobmann 13 - Niederösterreich',
                type: 'boolean', show: false, value: null, tab: 0},
            {name: 'sportobmann_14', label: 'Sportobmann 14 - Oberösterreich',
                type: 'boolean', show: false, value: null, tab: 0},
            {name: 'sportobmann_15', label: 'Sportobmann 15 - Salzburg',
                type: 'boolean', show: false, value: null, tab: 0},
            {name: 'sportobmann_16', label: 'Sportobmann 16 - Steiermark',
                type: 'boolean', show: false, value: null, tab: 0},
            {name: 'sportobmann_17', label: 'Sportobmann 17 - Tirol',
                type: 'boolean', show: false, value: null, tab: 0},
            {name: 'sportobmann_18', label: 'Sportobmann 18 - Vorarlberg',
                type: 'boolean', show: false, value: null, tab: 0},
            {name: 'sportobmann_19', label: 'Sportobmann 19 - Wien',
                type: 'boolean', show: false, value: null, tab: 0},
            {name: 'meisterschaftOperator_1', label: 'Operator 1 Nationale Ligen',
                type: 'boolean', show: false, value: null, tab: 1},
            {name: 'meisterschaftOperator_11', label: 'Operator 11 - Burgenland',
                type: 'boolean', show: false, value: null, tab: 1},
            {name: 'meisterschaftOperator_12', label: 'Operator 12 - Kärnten',
                type: 'boolean', show: false, value: null, tab: 1},
            {name: 'meisterschaftOperator_13', label: 'Operator 13 - Niederösterreich',
                type: 'boolean', show: false, value: null, tab: 1},
            {name: 'meisterschaftOperator_14', label: 'Operator 14 - Oberösterreich',
                type: 'boolean', show: false, value: null, tab: 1},
            {name: 'meisterschaftOperator_15', label: 'Operator 15 - Salzburg',
                type: 'boolean', show: false, value: null, tab: 1},
            {name: 'meisterschaftOperator_16', label: 'Operator 16 - Steiermark',
                type: 'boolean', show: false, value: null, tab: 1},
            {name: 'meisterschaftOperator_17', label: 'Operator 17 - Tirol',
                type: 'boolean', show: false, value: null, tab: 1},
            {name: 'meisterschaftOperator_18', label: 'Operator 18 - Vorarlberg',
                type: 'boolean', show: false, value: null, tab: 1},
            {name: 'meisterschaftOperator_19', label: 'Operator 19 - Wien',
                type: 'boolean', show: false, value: null, tab: 1},
        ]
    }
}